import React, { useContext, useState } from 'react'
import SingleUserManage from './UserManage'
import ProductCommonContext from '@/product/context/common/commonContext'
import * as Yup from 'yup'
import SettingState from '@/product/context/setting/settingState'

function Custom(props) {
    const { allCountries, allStates } = useContext(ProductCommonContext)
    const [updatedFormik, setUpdatedFormik] = useState({})
    const t = (e) => e
    const [initialValues, setInitialValues] = useState({
        id: 0,
        email: '',
        confirm_email: '',
        first_name: '',
        last_name: '',
        phone: '',
        address1: '',
        city: '',
        country: global.defaultCountry,
        state: global.defaultState,
        zip: '',
    })
    const allFormData = {
        validationObject: Yup.object({
            first_name: Yup.string()
                .min(2, 'Minimum 2 characters')
                .max(250, 'Maximum 250 characters')
                .required('Required!'),
            last_name: Yup.string()
                .min(2, 'Minimum 2 characters')
                .max(250, 'Maximum 250 characters')
                .required('Required!'),
            email: Yup.string()
                .email('Invalid email format')
                .max(250, 'Maximum 250 characters')
                .required('Required'),
            confirm_email:
                props.data.status === 'new'
                    ? Yup.string()
                          .email('Invalid email format')
                          .oneOf([Yup.ref('email')], "Email's not match")
                          .required('Required!')
                    : Yup.string(),
            phone: Yup.string()
                .trim()
                .matches(/^[0-9- +()]*$/g, 'Only Numbers Are Allowed')
                .required('Required'),
            address1: Yup.string().required('Required'),
            country: Yup.string().trim().required('Required'),
            state: Yup.string().trim().required('Required'),
        }),
        IndividualRegistration: {
            data: [
                {
                    label: 'First Name' + '*',
                    name: 'first_name',
                    type: 'text',
                    placeholder: 'Enter Your First Name',
                    class: 'col-12 col-sm-6',
                    autoFocus: true,
                },
                {
                    label: 'Last Name' + '*',
                    name: 'last_name',
                    type: 'text',
                    placeholder: 'Enter Your Last Name',
                    class: 'col-12 col-sm-6',
                },
                {
                    label: 'Email address' + '*',
                    name: 'email',
                    type: 'email',
                    placeholder: 'Enter Your Email Address',
                    class: 'col-12 col-sm-6',
                },
                {
                    onlyFor: ['new'],
                    label: 'Confirm Email Address' + '*',
                    name: 'confirm_email',
                    type: 'email',
                    placeholder: 'Enter Your Email Address',
                    class: 'col-12 col-sm-6',
                },
                {
                    label: 'Mobile Number' + '*',
                    name: 'phone',
                    type: 'phone',
                    placeholder: 'Mobile Number',
                    class: 'col-12 col-sm-6',
                },
                {
                    label: 'Country *',
                    placeholder: 'Enter your country',
                    class: `col-sm-6 col-12`,
                    type: 'select',
                    options: allCountries
                        .filter(
                            (country) =>
                                global.ignoreCountry.indexOf(
                                    country.isoCode
                                ) === -1
                        )
                        .map((country) => {
                            let busCategoryChanged = {}
                            busCategoryChanged.show = country.name
                            busCategoryChanged.value = country.isoCode
                            return busCategoryChanged
                        }),
                    name: 'country',
                },
                {
                    label: 'State *',
                    placeholder: 'Enter your state',
                    class: `col-sm-6 col-12`,
                    type: 'select',
                    options: allStates
                        .filter(
                            (state) =>
                                (updatedFormik.country
                                    ? updatedFormik.country.indexOf(
                                          state.countryCode
                                      ) !== -1
                                    : global.defaultCountry.indexOf(
                                          state.countryCode
                                      ) !== -1) &&
                                global.ignoreStates.indexOf(state.isoCode) ===
                                    -1
                        )
                        .map((buscat) => {
                            let busCategoryChanged = {}
                            busCategoryChanged.show = buscat.name
                            busCategoryChanged.value = buscat.isoCode
                            return busCategoryChanged
                        }),
                    name: 'state',
                },
                {
                    label: 'City' + '*',
                    name: 'city',
                    type: 'text',
                    placeholder: 'Enter your city',
                    class: 'col-12 col-sm-6',
                },
                {
                    label: 'Address' + '*',
                    name: 'address1',
                    type: 'text',
                    placeholder: 'Enter your address',
                    class: 'col-12 col-sm-6',
                },
                {
                    label: 'Po box' + '*',
                    placeholder: 'Enter your post box number',
                    class: 'col-12 col-sm-3',
                    type: 'number',
                    name: 'zip',
                },
            ],
        },
    }

    const editFunction = (data) => {
        let user = data
        setInitialValues({
            id: user.id,
            first_name: user.first_name ? user.first_name : '',
            last_name: user.last_name ? user.last_name : '',
            phone: user.phone ? user.phone : '',
            email: user.email,
            confirm_email: user.confirm_email,
            allow_cash_payment: user.allow_cash_payment == 1 ? true : false,
            companyname: user.companyname,
            company_id: user.company_id,
            country: user.country ? user.country : global.defaultCountry,
            state: user.state ? user.state : global.defaultState,
            city: user.city ? user.city : '',
            address1: user.address1 ? user.address1 : '',
            address2: user.address2 ? user.address2 : '',
            zip: user.zip ? user.zip : '',
        })
    }

    const updatedValues = (data) => {
        setUpdatedFormik(data)
    }

    const resetFrom = () => {
        setInitialValues({
            id: 0,
            email: '',
            confirm_email: '',
            first_name: '',
            last_name: '',
            phone: '',
            address1: '',
            city: '',
            country: global.defaultCountry,
            state: global.defaultState,
            zip: '',
        })
    }

    return (
        <SingleUserManage
            data={props.data}
            functionPopup={props.function}
            allFormData={allFormData}
            updatedValues={updatedValues}
            initialValues={initialValues}
            editFunction={editFunction}
            resetFrom={resetFrom}
        />
    )
}
export default Custom
